module.exports = __webpack_public_path__ + "static/media/class_job_020.9600ea61.svg";